var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5823 2.69482H9.11927C4.88774 2.69482 2.77197 4.81059 2.77197 9.04213V22.7946C2.77197 23.3764 3.24802 23.8525 3.82986 23.8525H17.5823C21.8139 23.8525 23.9296 21.7367 23.9296 17.5052V9.04213C23.9296 4.81059 21.8139 2.69482 17.5823 2.69482Z",
    stroke: "white",
    strokeWidth: 1.58683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3131 8.87256L8.82266 14.363C8.61108 14.5745 8.41009 14.9871 8.36778 15.2833L8.07157 17.3779C7.96578 18.1396 8.49472 18.6686 9.2564 18.5628L11.351 18.2666C11.6472 18.2242 12.0598 18.0232 12.2714 17.8117L17.7618 12.3213C18.7033 11.3797 19.1582 10.2795 17.7618 8.88313C16.3654 7.47615 15.2652 7.92046 14.3131 8.87256Z",
    stroke: "white",
    strokeWidth: 1.58683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5308 9.65552C13.9962 11.3164 15.2974 12.6282 16.9689 13.0936",
    stroke: "white",
    strokeWidth: 1.58683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEdit);
export default __webpack_public_path__ + "static/media/message-edit.5095705874283549ad737c18953633a3.svg";
export { ForwardRef as ReactComponent };